<template>
    <div class="index">
        <van-nav-bar
            title="经销商列表"
            fixed
            placeholder
            :left-arrow="false"
            @click-left="onClickLeft"
        >
            <template #right>
                <van-button
                    plain
                    hairline
                    type="info"
                    size="mini"
                    @click="logout"
                    >退出登录</van-button
                >
            </template>
        </van-nav-bar>
        <van-sticky offset-top="51">
            <van-search
                v-model="tenant_name"
                show-action
                placeholder="请输入经销商名称"
                @search="onSearch"
            >
                <template #action>
                    <van-button
                        type="info"
                        icon="search"
                        size="small"
                        @click="onSearch"
                        >搜索</van-button
                    >
                </template>
            </van-search>
        </van-sticky>
        <div class="content">
            <List
                v-model="loading"
                :finished="finished"
                :error="loadError"
                :error-text="loadErrorText"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <div
                    v-for="item in list"
                    :key="item.id"
                    class="distributor-card"
                    @click="showDistributorPop(item)"
                >
                    <div class="distributor-info">
                        <div class="info-item">
                            <span class="detail-label">名称：</span>
                            <span class="detail-value">{{ item.name }}</span>
                        </div>
                        <div class="info-item">
                            <span class="detail-label">公司名称：</span>
                            <span class="detail-value">{{
                                item.company_name
                            }}</span>
                        </div>
                        <div class="info-item">
                            <span class="detail-label">所属地区：</span>
                            <span class="detail-value">{{ item.area }}</span>
                        </div>
                    </div>
                </div>
            </List>
        </div>
        <van-popup
            v-model="distributorShow"
            position="bottom"
            :style="{ width: '100%', borderRadius: '12px 12px 0 0' }"
        >
            <div class="distributor-popup">
                <!-- 顶部统计模块 -->
                <div class="stats-module">
                    <div class="stats-item">
                        <div class="stats-label">红包余额</div>
                        <div class="stats-value">
                            ¥{{ overviewData.red_balance || 0 }}
                        </div>
                    </div>
                    <div class="stats-item">
                        <div class="stats-label">流量余额</div>
                        <div class="stats-value">
                            {{ overviewData.cdn_balance || 0 }}GB
                        </div>
                    </div>
                    <div class="stats-item">
                        <div class="stats-label">直播流量余额</div>
                        <div class="stats-value">
                            {{ overviewData.live_balance || 0 }}GB
                        </div>
                    </div>
                    <div class="stats-item">
                        <div class="stats-label">群管数量</div>
                        <div class="stats-value">
                            {{ overviewData.employee_count || 0 }}
                        </div>
                    </div>
                    <div class="stats-item">
                        <div class="stats-label">会员数量</div>
                        <div class="stats-value">
                            {{ overviewData.member_count || 0 }}
                        </div>
                    </div>
                </div>

                <!-- 时间筛选模块 -->
                <div class="time-filter-module">
                    <div class="filter-title">时间筛选</div>
                    <div class="date-picker-container">
                        <div class="date-picker-item">
                            <van-cell
                                title="选择日期"
                                :value="dateRange"
                                clickable
                                @click="showDatePicker = true"
                            />
                            <van-calendar
                                color="#1989fa"
                                v-model="showDatePicker"
                                type="range"
                                allow-same-day
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="onDateRangeConfirm"
                            />
                        </div>
                    </div>
                </div>

                <!-- 底部统计模块 -->
                <div class="performance-module">
                    <div class="performance-row">
                        <div class="performance-item">
                            <div class="performance-label">观看人数</div>
                            <div class="performance-value">
                                {{ analysisData.watch_count || 0 }}
                            </div>
                        </div>
                        <div class="performance-item">
                            <div class="performance-label">完播人数</div>
                            <div class="performance-value">
                                {{ analysisData.finish_count || 0 }}
                            </div>
                        </div>
                        <div class="performance-item">
                            <div class="performance-label">完播率</div>
                            <div class="performance-value">
                                {{ analysisData.finish_rate || 0 }}%
                            </div>
                        </div>
                    </div>

                    <div class="performance-row">
                        <div class="performance-item">
                            <div class="performance-label">答题人数</div>
                            <div class="performance-value">
                                {{ analysisData.answer_count || 0 }}
                            </div>
                        </div>
                        <div class="performance-item">
                            <div class="performance-label">正确人数</div>
                            <div class="performance-value">
                                {{ analysisData.correct_count || 0 }}
                            </div>
                        </div>
                        <div class="performance-item">
                            <div class="performance-label">正确率</div>
                            <div class="performance-value">
                                {{ analysisData.correct_rate || 0 }}%
                            </div>
                        </div>
                    </div>

                    <div class="performance-row">
                        <div class="performance-item">
                            <div class="performance-label">考核次数</div>
                            <div class="performance-value">
                                {{ analysisData.exam_count || 0 }}
                            </div>
                        </div>
                        <div class="performance-item">
                            <div class="performance-label">考核金额</div>
                            <div class="performance-value">
                                ¥{{ analysisData.exam_amount || 0 }}
                            </div>
                        </div>
                        <div class="performance-item">
                            <div class="performance-label">消耗流量</div>
                            <div class="performance-value">
                                {{ analysisData.traffic_consumption || 0 }}GB
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { List, Popup, Icon, Field, Calendar, Cell } from "vant";
import {
    tenantGetUserList,
    tenantAnalysisOverview,
    tenantOverview,
    tenantLogout,
} from "@/api/tenant";
import { getCookie, removeCookie } from "@/plugins/utils";
export default {
    name: "list",
    components: {
        List,
        VanPopup: Popup,
        VanIcon: Icon,
        VanField: Field,
        VanCalendar: Calendar,
        VanCell: Cell,
    },
    data() {
        return {
            pages: 1,
            page_size: 10,
            list: [],
            finished: false,
            loading: false,
            loadError: false,
            loadErrorText: "",
            distributorShow: false,
            showDatePicker: false,
            dateRange: "",
            startDate: "",
            endDate: "",
            selectedDistributor: {},
            minDate: new Date("2024-01-01"),
            maxDate: new Date("2030-01-01"),
            overviewData: {},
            analysisData: {},
            tenant_name: "",
        };
    },
    created() {
        this.startDate = this.formatDate(new Date());
        this.endDate = this.formatDate(new Date());
        this.dateRange = `${this.startDate} - ${this.endDate}`;
        this.getList();
    },
    methods: {
        onSearch() {
            this.getList();
        },
        showDistributorPop(item) {
            this.selectedDistributor = item;
            Promise.all([
                this.getTenantOverview(item.id),
                this.getTenantAnalysisOverview(item.id),
            ]).then(([overview, analysis]) => {
                if (overview.code == 1) {
                    this.overviewData = overview.data;
                } else if (overview.code == 401) {
                    removeCookie("tenant_personbench_token");
                    removeCookie("tenant_person");
                    this.$router.push("/double/login");
                }
                if (analysis.code == 1) {
                    this.analysisData = analysis.data;
                }
                this.distributorShow = true;
            });
        },
        getTenantOverview(id) {
            return tenantOverview({
                token: getCookie("tenant_personbench_token"),
                tenant_id: id,
            });
        },
        getTenantAnalysisOverview(id) {
            return tenantAnalysisOverview({
                token: getCookie("tenant_personbench_token"),
                tenant_id: id,
                start_time: this.startDate + " 00:00:00",
                end_time: this.endDate + " 23:59:59",
            });
        },
        onClickLeft() {
            this.$router.back();
        },
        onLoad() {},
        getList() {
            this.loading = true;
            tenantGetUserList({
                token: getCookie("tenant_personbench_token"),
                tenant_name: this.tenant_name,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.list = res.data;
                        this.finished = true;
                        this.loadError = false;
                        this.loadErrorText = "";
                    } else if (res.code == 401) {
                        removeCookie("tenant_personbench_token");
                        removeCookie("tenant_person");
                        this.$router.push("/double/login");
                    } else {
                        this.loadError = true;
                        this.loadErrorText = res.message;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.loadError = true;
                    this.loadErrorText = "加载失败，请重试";
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 格式化日期
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        logout() {
            let token = getCookie("tenant_personbench_token");
            removeCookie("tenant_personbench_token");
            removeCookie("tenant_person");
            tenantLogout({
                token,
            }).finally(() => {
                this.$router.push("/double/login");
            });
        },
        // 处理日期区间选择
        onDateRangeConfirm(date) {
            const [start, end] = date;
            this.showDatePicker = false;
            this.startDate = this.formatDate(start);
            this.endDate = this.formatDate(end);
            this.dateRange = `${this.formatDate(start)} - ${this.formatDate(
                end
            )}`;
            this.getTenantAnalysisOverview(this.selectedDistributor.id)
                .then((res) => {
                    if (res.code == 1) {
                        this.analysisData = res.data;
                    } else {
                        this.analysisData = {};
                        Toast.fail(res.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.analysisData = {};
                    Toast.fail("加载失败，请重试");
                });
        },
    },
};
</script>
<style scoped lang="less">
.index {
    background: #f5f5f5;
    min-height: 100vh;
}
.content {
    padding: var(--base-px-12);
}
.distributor-card {
    background: #ffffff;
    border-radius: var(--base-px-8);
    margin-bottom: var(--base-px-12);
    padding: var(--base-px-16);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    cursor: pointer;
}

.distributor-info {
    display: flex;
    flex-direction: column;
    gap: var(--base-px-6);
}

.info-item {
    font-size: var(--base-px-14);
    color: #666666;
    display: flex;
    align-items: center;
}

.detail-label {
    color: #999999;
    margin-right: var(--base-px-8);
    width: var(--base-px-80);
    text-align: right;
    flex-shrink: 0;
}

.detail-value {
    color: #333333;
    flex: 1;
    word-break: break-all;
}

/* 弹窗样式 */
.distributor-popup {
    padding: 20px;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
    background: #ffffff;
}

.popup-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    padding: 8px;
    z-index: 10;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
        background: rgba(245, 245, 245, 0.8);
    }
}

/* 统计模块 */
.stats-module {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
    padding: 10px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2);
}

.stats-item {
    text-align: center;
    color: #ffffff;
}

.stats-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 8px;
}

.stats-value {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
}

/* 时间筛选模块 */
.time-filter-module {
    margin-bottom: 16px;
    padding: 10px;
    background: #f5f5f5;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 8px;
}

.date-picker-container {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.date-picker-item {
    flex: 1;
    min-width: 250px;
}

.date-label {
    display: block;
    font-size: 14px;
    color: #666666;
    margin-bottom: 8px;
}

/* 性能统计模块 */
.performance-module {
    padding: 10px;
    background: #f5f5f5;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.performance-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
}

.performance-item {
    flex: 1;
    text-align: center;
    padding: 12px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.performance-label {
    font-size: 14px;
    color: #666666;
    margin-bottom: 8px;
}

.performance-value {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
}

/deep/ .van-cell__title {
    flex: none;
}

/deep/ .van-cell {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
</style>
